import React from 'react';
import { Box } from '@mui/material';

/**
 * Responsive 16:9 YouTube embed.
 *
 * Accepts a full YouTube URL (youtu.be/ID, watch?v=ID, or /embed/ID) or a bare
 * 11-char video ID. Returns null if no valid ID can be parsed (so callers can
 * drop it in unconditionally). Used for onboarding + the help-video icons.
 */
function extractYouTubeId(input) {
  if (!input) return null;
  const s = String(input).trim();
  if (/^[\w-]{11}$/.test(s)) return s; // already a bare id
  const m = s.match(/(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/)([\w-]{11})/);
  return m ? m[1] : null;
}

const VideoEmbed = ({ url, title = 'Video', maxWidth = 720 }) => {
  const id = extractYouTubeId(url);
  if (!id) return null;

  return (
    <Box sx={{ width: '100%', maxWidth, mx: 'auto' }}>
      <Box
        sx={{
          position: 'relative',
          pb: '56.25%', // 16:9
          height: 0,
          borderRadius: 2,
          overflow: 'hidden',
          boxShadow: 3,
          bgcolor: '#000'
        }}
      >
        <Box
          component="iframe"
          src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
        />
      </Box>
    </Box>
  );
};

export default VideoEmbed;
